import { render, staticRenderFns } from "./ProductoImagenFormComponent.vue?vue&type=template&id=26eff6bc&"
import script from "./ProductoImagenFormComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoImagenFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports